import { render } from "./SVGConfirm.vue?vue&type=template&id=8d102508"
import script from "./SVGConfirm.vue?vue&type=script&lang=js"
export * from "./SVGConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__